"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _overrides = require("../../../utils/overrides");

var _Popover = _interopRequireDefault(require("../../utils/Popover"));

var _Icon = _interopRequireDefault(require("../../general/Icon"));

var _Text = _interopRequireDefault(require("../../typography/Text"));

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Label');

function Label(_ref) {
  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      isRequired = _ref.isRequired,
      hint = _ref.hint,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "isRequired", "hint"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, _Text.default.overrides); // Classes

  var rootClassName = (0, _classnames.default)(classes.root, classNameProp);
  var rootProps = {
    className: rootClassName
  };
  return /*#__PURE__*/_react.default.createElement("span", (0, _extends2.default)({}, rootProps, override.root), /*#__PURE__*/_react.default.createElement(_Text.default, (0, _extends2.default)({
    className: classes.Text
  }, override.Text), children, isRequired && '*'), hint && /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({
    className: classes.Popover,
    placement: "top",
    trigger: ['hover'],
    content: hint
  }, override.Popover), /*#__PURE__*/_react.default.createElement("span", {
    className: classes.info
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: classes.icon,
    name: "info"
  }))));
}

_Text.default.overrides = ['root', 'Popover', 'Text'];
_Text.default.defaultProps = {
  overrides: {}
};
_Text.default.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  isRequired: _propTypes.default.bool,
  hint: _propTypes.default.string
};

var _default = /*#__PURE__*/_react.default.memo(Label);

exports.default = _default;